export default __webpack_public_path__ + "static/media/puppy-linux.f97b282b.svg";